import { getAdminOrCareAdvisorPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const deleteUserById = async (userId: number, userRole?: string): Promise<UserProfile> => {
  const { data } = await client.delete<UserProfile>(`${getAdminOrCareAdvisorPrefix(userRole)}/users/${userId}`);

  return data;
};
